import { render, staticRenderFns } from "./RecommendedService.vue?vue&type=template&id=e0a12cdc&"
import script from "./RecommendedService.vue?vue&type=script&lang=js&"
export * from "./RecommendedService.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports